export const accountComponents = {
  // OtaLinksBar.vue — barra de enlaces de OTA
  otaLinks: {
    copied: "¡Copiado!",
    copy: "Copiar",
    edit: "Editar",
    remove: "Quitar",
    addLink: "link de OTA",
    modalEyebrow: "Enlace del anuncio en la OTA",
    modalEyebrowUnit: "Enlace de esta unidad en la OTA",
    editTitle: "Editar enlace",
    addTitle: "Añadir enlace de OTA",
    modalHint: "Pega la URL pública de <b>este anuncio</b> en la OTA. Sirve para copiarla y abrirla rápido.",
    urlLabel: "URL del anuncio",
    cancel: "Cancelar",
    saving: "Guardando…",
    save: "Guardar enlace",
    saveError: "No se pudo guardar el enlace. Revisa la URL.",
    fromListing: "del anuncio",
    inheritedNote: "Es el enlace del anuncio. Mientras esta unidad no tenga el suyo, es el que se envía.",
    override: "Poner el suyo",
    modalHintUnit: "Pega la URL pública de <b>esta unidad</b> en la OTA. Si la pones, manda esta; si la dejas vacía, manda la del anuncio.",
  },

  // GuestJourneySimulator.vue — simulador del recorrido del huésped
  journeySim: {
    title: "Simular recorrido del huésped",
    badge: "Test",
    intro: "Reproduce todo el proceso —desde la reserva hasta la reseña— en un WhatsApp. Pon un nombre y un número y dale a <strong>play</strong>. Si activas «Enviar al móvil», cada mensaje llega de verdad al número para que lo pruebes y hables con el Agente IA.",
    guestNameLabel: "Nombre del huésped",
    guestNamePlaceholder: "Ej. Laura García",
    phoneLabel: "Número de WhatsApp (para test)",
    phoneHint: "Formato internacional, p. ej. +34 600123456",
    toggleTitle: "Enviar también al móvil",
    toggleDesc: "Cada etapa se envía de verdad al número de arriba",
    warn: "Escribe primero «hola» al número desde tu móvil para abrir la ventana de 24h de WhatsApp; así recibirás los mensajes al instante.",
    reset: "Reiniciar",
    prev: "Anterior",
    pause: "Pausar",
    play: "Play",
    continue: "Continuar",
    next: "Siguiente",
    stepProgress: "Paso {current} de {total}",
    guestFallback: "Huésped",
    propertyFallback: "tu alojamiento",
    testNumberFallback: "número de prueba",
    dayLabel: "Recorrido del huésped",
    loadingMsgs: "Cargando tus mensajes…",
    pressPlay: "Pulsa <strong>Play</strong> para empezar el recorrido ▶",
    hintSending: "Modo envío real activo · cada paso llega a {phone}",
    hintSimulated: "Vista simulada · activa «Enviar al móvil» para probar en un teléfono real",
    toastInvalidPhone: "Escribe un número de WhatsApp válido para enviar al móvil.",
    toastSendFailed: "No se pudo enviar.",
    toastSendMobileFailed: "No se pudo enviar al móvil.",
    // Mensajes simulados de WhatsApp (los {{...}} los resuelve resolve())
    msgConfirmation: "Hola *{{nombre_huesped}}* 👋\n\nTu reserva en *{{nombre_alojamiento}}* está confirmada ✅\n\nCódigo de reserva: *6233Q1VC5*\nFechas: *{{fecha_entrada}}* – *{{fecha_salida}}* 📅\n\nPor este WhatsApp podrás solicitar tu link para el check-in online y recibir las indicaciones de llegada.",
    msgCheckinPrompt: "*Hola* 👋 Soy el asistente virtual de *{{nombre_alojamiento}}*.\n\nPresiona *Ok* para continuar con tu check-in.",
    msgChooseLanguage: "Elige tu idioma · Choose your language",
    msgCheckinLink: "*Gracias* 👋 Este es tu link para hacer el check-in 😎\n\nhttps://guest.wacheckin.com/checkin/6233Q1VC5",
    msgWelcome: "👋 ¡Bienvenido/a a *{{nombre_alojamiento}}*, {{nombre_huesped}}!\n\nGracias por completar tu registro. Aquí tienes toda la información de tu estancia.",
    msgAccess: "🔒🔑 *Código de acceso · {{nombre_alojamiento}}*\n\nTu código es: *58117*\n\nVálido durante toda tu estancia.",
    msgArrival: "🏡 *Instrucciones de llegada*\n\nAl llegar, dirígete a la entrada principal e introduce tu código en la cerradura. 🔑\n\n¡Feliz estancia! ✨",
    msgGuestCheckout: "Hola, ¿a qué hora es el check-out?",
    msgCheckoutReply: "¡Hola! El check-out es hasta las *12:00* 🕚 Si necesitas salir más tarde, puedo mirarte un late check-out 😊",
    msgCheckout: "Hola *{{nombre_huesped}}* 👋\n\nTe recordamos que *mañana finaliza tu estancia* en *{{nombre_alojamiento}}*.\n\n🕚 La hora máxima de salida es a las *{{hora_salida}}*.\n\n¡Muchas gracias por tu visita y buen viaje! 😊",
    msgReview: "⭐ ¿Qué tal tu estancia en *{{nombre_alojamiento}}*, {{nombre_huesped}}?\n\nNos encantaría conocer tu opinión. Déjanos tu reseña aquí 👉 https://g.page/r/review",
  },

  // GuestJourneyTimeline.vue — línea de tiempo del recorrido del huésped
  journeyTimeline: {
    title: "Recorrido del huésped",
    subtitle: "Desde la reserva hasta la salida. Pasa el ratón por cada evento para ver el mensaje.",
    disabled: "Desactivado",
    clickToConfigure: "Haz clic para configurar",
    nameFallback: "tu alojamiento",
    // Etiquetas de los nodos
    labelLead: "Reserva / Lead",
    labelConfirm: "Confirmación",
    labelCheckinLink: "Link de check-in",
    labelWelcome: "Bienvenida",
    labelAccess: "Acceso / Cerradura",
    labelArrival: "Instrucciones de llegada",
    labelCheckout: "Mensaje de salida",
    labelReview: "Reseña",
    // Momento de cada nodo
    whenLead: "Al reservar o escribir",
    whenConfirm: "Reserva confirmada",
    whenCheckinLink: "Antes de la llegada",
    whenWelcome: "Tras el registro",
    whenAccess: "Día de la llegada",
    whenArrival: "Día de la llegada",
    whenCheckout: "Víspera del checkout",
    whenReview: "Tras el checkout",
    // Vistas previas de WhatsApp
    previewLead: "👋 ¡Hola! Soy el asistente virtual de *{name}*.\n\nEstoy aquí para ayudarte con tu reserva y resolver cualquier duda.",
    previewConfirm: "Hola *Laura García* 👋\n\nTu reserva en *{name}* está confirmada ✅\n\nCódigo de reserva: *6233Q1VC5*\nFechas: *05/06/2026* – *07/06/2026* 📅\n\nPor este WhatsApp podrás solicitar tu link para el check-in online y, además, recibir las indicaciones de llegada.\nSi necesitas ayuda antes o durante la estancia, escríbenos por aquí 💬",
    previewWelcome: "👋 ¡Bienvenido/a a *{name}*!\n\nGracias por completar tu registro. Aquí tienes toda la información de tu estancia.",
    previewAccess: "🔒🔑 *Código de acceso · {name}*\n\nTu código es: *58117*\n\nVálido durante tu estancia.",
    previewArrival: "🏡 *Instrucciones de llegada*\n\nAl llegar, dirígete a la entrada principal del alojamiento. 🔑\n\n¡Feliz estancia! ✨",
    previewCheckout: "Hola 👋\n\nTe recordamos que *mañana finaliza tu estancia* en *{name}*.\n\n🕚 La hora máxima de salida es a las *12:00*.\n\n¡Buen viaje! 😊",
    previewReview: "⭐ ¿Qué tal tu estancia en *{name}*?\n\nNos encantaría conocer tu opinión. Déjanos tu reseña aquí 👉 …",
    previewLeadNoWaba: "📲 *Activa tu Agente IA* para atender nuevas reservas por WhatsApp conectando tu propio número.\n\nAsí el asistente responderá a personas que aún no son clientes respondiendo dudas sobre los alojamientos y guiándolos hacia la reserva.",
    // Conversación completa del "Link de check-in"
    chatCheckinAgent1: "🇪🇸 *Hola* 👋 Soy 🤖 el asistente virtual de *{name}*.\nEstoy aquí para ayudarte con el proceso de check-in.\n\nPresiona 'Ok' para continuar con el check-in.\n\n🇬🇧 *Hi* 👋 I'm 🤖 the virtual assistant of *{name}*.\nI'll help you with the check-in process.\n\nPress 'Ok' to continue with the check-in.",
    chatChooseLanguage: "Elige tu idioma · Choose your language",
    chatCheckinLink: "*Gracias* 👋 Este es tu link para hacer el Check-In. 😎\n\nhttps://guest.wacheckin.com/…",
    // Mensajes de acceso (cerraduras)
    lockLabelFallback: "Entrada",
    lockDynamic: "🔒🔑 *{label} · {name}*\n\nTu código de acceso es: *58117*\n\nVálido durante tu estancia.",
    lockNone: "🔑 *{label} · {name}*\n\nEl cajetín de llaves se abre con el código: *{code}*\n\nDentro encontrarás las llaves del alojamiento.",
    lockDefault: "🔒🔑 *{label} · {name}*\n\nEl código de la cerradura es: *{code}*\n\nÚsalo para abrir la puerta.",
    // Mensaje de salida (fallback)
    checkoutFallback: "Hola, *María* 👋\n\nTe recordamos que mañana finaliza tu estancia en *{name}*.\n\n🕚 La hora máxima de salida es a las *{time}*.\n\nMuchas gracias por tu estancia. ¡Buen viaje! 😊",
  },

  // ListingIcalPanel.vue — panel de sincronización iCal
  icalPanel: {
    eyebrow: "iCal Calendar",
    heading: "Sincronización iCal",
    pageDesc: "Exporta tus reservas a otras plataformas e importa calendarios externos para bloquear fechas automáticamente en tu anuncio.",
    loading: "Cargando configuración…",
    exportLabel: "Tu enlace iCal (exportar)",
    exportDesc: "Copia este enlace y pégalo en Airbnb, Booking.com, o cualquier plataforma que soporte sincronización por iCal. Ellos jalararán tus reservas automáticamente.",
    copied: "Copiado",
    copy: "Copiar",
    tipAllUnits: "Este enlace incluye las reservas de <strong>todas las unidades</strong> del anuncio.",
    tipHotelRooms: "Cada <strong>habitación física</strong> tiene su propio enlace. Conéctalo en Airbnb/Booking para esa habitación concreta y solo se exportarán las reservas de ESA habitación.",
    importLabel: "Calendarios externos (importar)",
    syncing: "Sincronizando…",
    syncAll: "Sincronizar todo",
    importDesc: "Pega las URLs de iCal de tus otras plataformas (Airbnb, Booking.com, etc.) y Wacheckin bloqueará automáticamente esas fechas en tu calendario.",
    lastSync: "Última sync: {date}",
    delete: "Eliminar",
    empty: "Aún no tienes calendarios externos vinculados.",
    addExternal: "Agregar calendario externo",
    newExternal: "Nuevo calendario externo",
    nameLabel: "Nombre del calendario",
    namePlaceholder: "Ej: Airbnb - Apto 1",
    physicalRoom: "Habitación física",
    listingUnit: "Unidad del anuncio",
    selectRoomPlaceholder: "Selecciona una habitación…",
    selectUnitPlaceholder: "Selecciona una unidad…",
    urlLabel: "URL del calendario iCal",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveSync: "Guardar y sincronizar",
    defaultGroup: "Habitaciones",
    toastLoadError: "No se pudo cargar la configuración iCal.",
    toastSelectUnit: "Selecciona una habitación / unidad.",
    toastAdded: "Calendario agregado y sincronizado correctamente.",
    toastAddError: "Error al agregar el calendario.",
    deleteConfirm: '¿Eliminar "{name}" y todas sus reservas bloqueadas?',
    toastDeleted: "Calendario eliminado.",
    toastDeleteError: "No se pudo eliminar el calendario.",
    toastSyncError: "Error al sincronizar.",
  },

  // ListingIcalModal.vue — modal de sincronización iCal
  icalModal: {
    title: "Sincronización iCal",
    loading: "Cargando configuración…",
    exportLabel: "Tu enlace iCal (exportar)",
    exportDesc: "Copia este enlace y pégalo en Airbnb, Booking.com, o cualquier plataforma que soporte sincronización por iCal. Ellos jalarán tus reservas automáticamente.",
    copied: "Copiado",
    copy: "Copiar",
    tipAllUnits: "Este enlace incluye las reservas de <strong>todas las unidades</strong> del anuncio.",
    tipHotelRooms: "Cada <strong>habitación física</strong> tiene su propio enlace. Conéctalo en Airbnb/Booking para esa habitación concreta y solo se exportarán las reservas de ESA habitación.",
    importLabel: "Calendarios externos (importar)",
    syncing: "Sincronizando…",
    syncAll: "Sincronizar todo",
    importDesc: "Pega las URLs de iCal de tus otras plataformas (Airbnb, Booking.com, etc.) y Wacheckin bloqueará automáticamente esas fechas en tu calendario.",
    lastSync: "Última sync: {date}",
    delete: "Eliminar",
    empty: "Aún no tienes calendarios externos vinculados.",
    addExternal: "Agregar calendario externo",
    newExternal: "Nuevo calendario externo",
    nameLabel: "Nombre del calendario",
    namePlaceholder: "Ej: Airbnb - Apto 1",
    physicalRoom: "Habitación física",
    listingUnit: "Unidad del anuncio",
    selectRoomPlaceholder: "Selecciona una habitación…",
    selectUnitPlaceholder: "Selecciona una unidad…",
    urlLabel: "URL del calendario iCal",
    cancel: "Cancelar",
    saveSync: "Guardar y sincronizar",
    defaultGroup: "Habitaciones",
    toastLoadError: "No se pudo cargar la configuración iCal.",
    toastSelectUnit: "Selecciona una habitación / unidad.",
    toastAdded: "Calendario agregado y sincronizado correctamente.",
    toastAddError: "Error al agregar el calendario.",
    deleteConfirm: '¿Eliminar "{name}" y todas sus reservas bloqueadas?',
    toastDeleted: "Calendario eliminado.",
    toastDeleteError: "No se pudo eliminar el calendario.",
    toastSyncError: "Error al sincronizar.",
  },
};
